import { Box, Tab, Tabs, Typography } from "@mui/material";
import { SyntheticEvent, useState } from "react";
import { TitleSection } from "../../components/TitleSection";
import { VerticalSlider } from "../../components/sliderPage/verticalSlider";

const arrTab = [
  {
    label: "Big Ten Conference",
    color: { permanently: "var(--c-bg-content-color)", hover: "#075077" },
    icon: "/img/project/bigTen/B1G_News_Feed_Logo.svg",
    cover: "/img/project/bigTen/BigTen_View.png",
    desc: "The Big Ten Conference (B1G) is the oldest NCAA Division I collegiate athletic conference in the United States, founded in 1896. Initially consisting of ten universities, the conference expanded to 18 member and 2 affiliate institutions in August 2024. It is based in Rosemont, Illinois, and its football teams compete in the NCAA’s Football Bowl Subdivision (FBS), the highest level of competition.",
    link: "https://bigten.org/",
  },
  {
    label: "Southern Conference",
    color: { permanently: "var(--c-bg-content-color)", hover: "#94190E" },
    icon: "/img/project/soCon/Southern_Conference_logo.png",
    cover: "/img/project/soCon/SoCon_View.png",
    desc: "The Southern Conference (SoCon) is a collegiate athletic conference in Division I of the National Collegiate Athletic Association (NCAA). The football teams of the Southern Conference compete in the Football Championship Subdivision (formerly known as Division I-AA). Member institutions are located in the states of Alabama, Georgia, North Carolina, South Carolina, Tennessee, and Virginia.",
    link: "https://soconsports.com/",
  },
  {
    label: "Abbott",
    color: { permanently: "var(--c-bg-content-color)", hover: "#075077" },
    icon: "/img/project/abbott/images-removebg-preview.png",
    cover: "/img/project/abbott/Abbott_View.png",
    desc: "Together, Abbott and the Big Ten will use sports for good by championing a conference-wide blood donation competition, “The We Give Blood Drive,” to help rebuild the nation’s blood supply and ensure no one in need of blood has to go without.",
    link: "https://bigten.org/abbott/",
  },
  {
    label: "Aircon",
    color: { permanently: "var(--c-bg-content-color)", hover: "#EC6F2D" },
    icon: "/img/project/aircon/ZGuwGWEN_400x4001.png",
    cover: "/img/project/aircon/NewQuote-_dUYiZA6.png",
    desc: "Aircon is the first platform designed to enable  small and medium forwarders to compete with larger companies, in the air freight business. A kind of modern day David vs Goliath. Using technology and proprietary processes, Aircon executes time-sensitive consolidation of your shipment right up to wheels-up so that you receive the best possible pricing.",
    link: "https://www.airconai.com/",
  },
  {
    label: "Resurrection",
    color: { permanently: "var(--c-bg-content-color)", hover: "#330C82" },
    icon: "/img/project/resurrection/unnamed.webp",
    cover: "/img/project/resurrection/resurrection-removebg-preview.png",
    desc: "This is a project of the media ministry of Resurrection Church, which was created to improve, conveniently store, preserve and freely use the numerous spiritual materials of the community. The ministry team has worked hard to ensure that every member of the church and beyond has constant access to songs, God's Word, and other church-building materials.",
    link: "https://play.google.com/store/apps/details?id=com.resurrectionchurch",
  },
  {
    label: "Hope For Ukraine Bot",
    color: { permanently: "var(--c-bg-content-color)", hover: "#8B8222" },
    icon: "/img/project/hfu/HFU_logo.png",
    cover: "/img/project/hfu/HFU.png",
    desc: "'Hope For Ukraine Bot' is a bot designed to provide a convenient photo and video report on the distribution of humanitarian aid from Hope for Ukraine.",
    link: "",
  },
  {
    label: "BOOST",
    color: { permanently: "var(--c-bg-content-color)", hover: "#242209" },
    icon: "/img/project/boost/Boost_Demo_logo.svg",
    cover: "/img/project/boost/boost_view.png",
    desc: "BOOST is a platform that captures, ingests, and transforms live sports data into automated narrative and visual content. This innovative media solution enables sports properties and publishers to engage fans and convert them into customers. Using computer vision, analytics, and natural language technologies, BOOST creates new media assets and seamlessly integrates third-party solutions to offer continuous storytelling. The platform is active across eight major global sports, serving all levels from grassroots to professional leagues.",
    link: "https://boostsport.ai/",
  },
];

function TabPanel(props: any) {
  const { elem, value, index, ...other } = props;

  return (
    <Box
      sx={{
        width: {
          xs: "100%",
          sm: "400px",
          md: "500px",
        },
        height: {
          xs: "400px",
          md: "100%",
        },
      }}
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            width: "100%",
            flexDirection: "row",
          }}
        >
          <Box sx={{ flex: 1, width: "100%" }}>
            <Box
              sx={{
                width: "100%",
                borderRadius: 2,
                border: "3px solid var(--c-bg-content-color)",
                display: "flex",
                flexDirection: "column",
                boxShadow: "var(--c-box-shadow-btn)",
                backgroundColor: "var(--c-bg-content-color)",
                height: {
                  xs: "400px",
                  md: "435px",
                },
              }}
            >
              <Box
                component="img"
                src={elem?.cover || ""}
                alt="green iguana"
                sx={{
                  objectFit: "cover",
                  height: "200px",
                  "&:hover": {
                    height: "300px",
                  },
                }}
              />
              <Box
                sx={{
                  overflow: "hidden",
                  flexDirection: "column",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "50%",
                  color: "var(--c-text-color)",
                  p: "10px 10px 8px 10px",
                }}
              >
                <Typography
                  component={"a"}
                  href={elem?.link || ""}
                  gutterBottom
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    "&.MuiTypography-root": {
                      textDecoration: elem?.link ? "underline" : "none",
                      color: "inherit",
                    },
                  }}
                >
                  {elem?.label || ""}
                </Typography>
                <Typography
                  component="div"
                  sx={{
                    fontSize: {
                      xs: "12px",
                      md: "15px",
                    },
                    fontWeight: 100,
                    overflowY: "scroll",
                    scrollbarWidth: 'thin'
                  }}
                >
                  {elem?.desc || ""}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const SecProjects = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <VerticalSlider />
      <Box
        id={"projects"}
        sx={{
          paddingX: {
            xs: "15px",
            sm: "50px",
            md: "70px",
          },
          mt: "86px",
        }}
      >
        <Box sx={{ mb: "20px" }}>
          <TitleSection title={"Projects"} value={60} />
        </Box>
        <Box
          sx={{
            p: 2,
            display: "flex",
            flexDirection: {
              xs: "column",
              sm: "column",
              md: "row",
            },
            height: {
              xs: "560px",
              md: "550px",
              lg: "470px",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flex: 1,
              minHeight: {
                xs: "100px",
              },
              height: {
                xs: "100px",
                sm: "140px",
                md: "100%",
              },
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="Vertical tabs example"
              TabIndicatorProps={{
                sx: {
                  height: "0px",
                },
              }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "var(--c-text-color)",
                height: {
                  xs: "750px",
                  sm: "400px",
                  md: "400px",
                  lg: "470px",
                },
                "& .MuiTabs-flexContainer": {
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                },
              }}
            >
              {arrTab?.map((el: any, inx: number) => (
                <Tab
                  component="div"
                  icon={
                    <Box
                      alt={""}
                      component="img"
                      sx={{
                        filter: "grayscale(100%)",
                        width: {
                          xs: "30px",
                          sm: "50px",
                          md: "50px",
                          lg: "70px",
                        },
                        height: {
                          xs: "30px",
                          sm: "50px",
                          md: "50px",
                          lg: "70px",
                        },
                        "&.Mui-selected": {
                          backgroundColor: `${el?.color?.permanently}`,
                          color: "black",
                        },
                        "&.Mui-focusVisible": {
                          backgroundColor: "#d1eaff",
                        },
                      }}
                      src={el?.icon || ""}
                    />
                  }
                  sx={{
                    color: "var(--c-text-color)",
                    m: {
                      xs: 1,
                      sm: 1,
                      md: 2,
                      lg: 2,
                    },
                    padding: 0,
                    backgroundColor: `${el?.color?.permanently}`,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "30px",
                    boxShadow: "var(--c-box-shadow-btn)",
                    minWidth: {
                      xs: "50px",
                      sm: "80px",
                      md: "90px",
                      lg: "100px",
                    },
                    minHeight: {
                      xs: "50px",
                      sm: "80px",
                      md: "90px",
                      lg: "100px",
                    },
                    overflow: "visible !important",
                    transition: "all 0.3s ease-in-out",
                    border: "2px solid var(--c-bg-content-color)",
                    "&.Mui-selected": {
                      backgroundColor: `${el?.color?.permanently}`,
                      "& img": {
                        filter: "grayscale(0%)",
                      },
                    },
                    "&:hover": {
                      backgroundColor: `${el?.color?.hover}`,
                      "& img": {
                        filter: "grayscale(0%)",
                      },
                    },
                  }}
                  label={""}
                  {...a11yProps(inx)}
                />
              ))}
            </Tabs>
          </Box>
          <Box sx={{ display: "flex", flex: 1 }}>
            {arrTab?.map((el: any, inx: number) => (
              <TabPanel value={value} index={inx} elem={el} />
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
};
